import { render, staticRenderFns } from "./MyRequest.vue?vue&type=template&id=61737ef6&scoped=true&"
import script from "./MyRequest.vue?vue&type=script&lang=js&"
export * from "./MyRequest.vue?vue&type=script&lang=js&"
import style0 from "./MyRequest.vue?vue&type=style&index=0&id=61737ef6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61737ef6",
  null
  
)

export default component.exports